export default state => state.payment.adyenV2.placeOrderData;
